module.exports = {
  eventCategory: 'Editor UI | Tool Menu | videos',

  show: { eventAction: 'show' }
};
